import {Controller} from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import {TextField} from "@mui/material";
import React from "react";
import {NumberFormatCustom} from "@vendor/examples/NumberFormat";

import type {Control, FieldValues, Path} from "react-hook-form";

export interface InputNumberFormatControllerProps<T extends FieldValues = FieldValues> {
    control: Control<T>;
    name: Path<T>;
    label: string;
    defaultValue?: unknown;
}

const InputNumberFormatController = <T extends FieldValues = FieldValues>({control, name, label, defaultValue}: InputNumberFormatControllerProps<T>) => {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue as never}
            render={({field}) => (
                <FormControl fullWidth>
                    <TextField
                        label={label}
                        margin="dense"
                        fullWidth
                        {...field}
                        name={name}
                        id="formatted-numberformat-input"
                        variant="outlined"
                        slotProps={{
                            input: { inputComponent: NumberFormatCustom },
                        }}
                    />
                </FormControl>
            )}
        />
    )
}

export default InputNumberFormatController;
